import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import fetch, { update } from '../../../Api/definitionCourseDepartment';

const useCourse = ({ departmentId }, setIsLoading) => {
  const history = useHistory();
  const [courses, setCourses] = useState([]);
  const [coursesByEnterprise, setCoursesByEnterprise] = useState();
  const [defaultSelectedIds, setDefaultSelectedIds] = useState([]);
  const [terminals, setTerminals] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch(departmentId).then(data => {
      setCourses(data.courseByDepartment);
      setCoursesByEnterprise(data.courseByEnterprise);
      setCategories(data.categories);
      setTerminals(data.terminals);
      setIsLoading(false);
      const idArr = [];
      data.courseByDepartment.forEach((courseArray, index) => {
        // checks 'isChecked' value
        if (courseArray[courseArray.length - 1]) {
          idArr.push(courseArray[5]);
        }
      });
      setDefaultSelectedIds(Array.from(idArr));
    });
  }, []);

  const saveCourses = courseData => {
    update(courseData, departmentId)
      .then(() => {
        history.push({
          pathname: '/definicion',
          state: {
            update: true,
          },
        });
      })
      .catch(err => err);
  };

  return {
    courses,
    setCourses,
    terminals,
    categories,
    saveCourses,
    coursesByEnterprise,
    defaultSelectedIds,
  };
};

export default useCourse;
